<template>
  <v-layout align-center justify-center row fill-height class="ma-0 grey lighten-1">
    <v-card>
      <v-card-title>
        <h2 class="text-h4">Not Authorised</h2>
      </v-card-title>
      <v-card-text>
        <p class="text-xs-center">You are not authorised to access this page.</p>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="logOut()" text>
          Logout
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn @click="signIn()" text class="success">
          Log In
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-layout>
</template>

<script lang="ts">
// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
import { Component, Prop, Vue } from 'vue-property-decorator';

import auth from '@/services/auth';

@Component({})
export default class NotAuthorized extends Vue {
    private show = true;

    private signIn(): void {
        auth.signIn();
    }

    private logOut(): void {
        this.$router.push({
            path: "/logout"
        });
    }
}
</script>

<style scoped>

.not-authorized-card .v-btn {
    margin-top: 10px;
}

</style>